import React from "react";
import { useQuery } from "react-query";

import api from "../api";
import { QUERY_KEYS } from "../constants";
import useProfile from "./useProfile";

const client = api();

export default function useChampions() {
  const {
    data: champions = [],
    isLoading: isFetchingChampions,
  } = useQuery(QUERY_KEYS.CHAMPS, () => client.getChamps());

  return { champions, isFetchingChampions };
}

export function useProfileChampions() {
  const { champions, isFetchingChampions } = useChampions();
  const { profile } = useProfile();
  const {
    data: profileUsedChampions = [],
    isLoading: isFetchingProfileChampions,
  } = useQuery(QUERY_KEYS.PROFILE_CHAMPS, () => client.getProfileChamps());

  const profileChampions = React.useMemo(
    () =>
      champions.map((champion) => {
        const usedChampion = profileUsedChampions.find(
          ({ champId }) => champId === champion.id,
        );
        const isCurrent =
          profile?.currentClassroomChamp?.champId === usedChampion?.champId;

        return usedChampion
          ? {
              ...usedChampion,
              isCurrent,
              bodyImageSources: {
                "regular@1x": usedChampion.images.full["1x"],
                "regular@2x": usedChampion.images.full["2x"],
                "regular@3x": usedChampion.images.full["3x"],
              },
              headImageSources: {
                "regular@1x": usedChampion.images.headshot["1x"],
                "regular@2x": usedChampion.images.headshot["2x"],
                "regular@3x": usedChampion.images.headshot["3x"],
              },
            }
          : {
              ...champion,
              graduated: false,
              bodyImageSources: {
                "regular@1x": champion.images.phase1.full["1x"],
                "regular@2x": champion.images.phase1.full["2x"],
                "regular@3x": champion.images.phase1.full["3x"],
              },
              headImageSources: {
                "regular@1x": champion.images.phase1.headshot["1x"],
                "regular@2x": champion.images.phase1.headshot["2x"],
                "regular@3x": champion.images.phase1.headshot["3x"],
              },
            };
      }),
    [champions, profileUsedChampions, profile],
  );
  return {
    profileChampions,
    isFetchingProfileChampions:
      isFetchingChampions || isFetchingProfileChampions,
  };
}
